import React from 'react';
import { CheckCircleIcon } from 'lucide-react';
export function WhatYouGet() {
  const items = [{
    title: 'The ADHD Operational User Manual',
    desc: 'A 35-page guide to navigating executive dysfunction.'
  }, {
    title: 'The 5-Minute "Dopamine-Menu" Builder',
    desc: 'Your personal inventory of focus triggers.'
  }, {
    title: 'The Task-Density Heatmap',
    desc: 'A visual tool to stop the lie of "it will only take five minutes."'
  }, {
    title: 'The "Un-Stuck" Decision Tree',
    desc: 'A literal map to follow when you are in a paralysis loop.'
  }, {
    title: 'The Body-Double Daily Planner',
    desc: 'Templates to leverage social presence for deep focus.'
  }, {
    title: 'The Emergency Reset Protocol',
    desc: 'The 15-minute sequence to save a "bad" day.'
  }];
  return <section className="py-16 md:py-24 px-4 bg-[#112240]" data-id="element-113">
      <div className="max-w-4xl mx-auto animate-fade-in-up delay-200" data-id="element-114">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-center text-[#F1F5F9] mb-12" data-id="element-115">
          What's Inside the Toolkit
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-116">
          {items.map((item, index) => <div key={index} className="bg-[#1A2F4A] p-6 rounded-xl border border-[#2DD4BF]/20 flex items-start gap-4 hover:border-[#2DD4BF]/50 transition-colors" data-id="element-117">
              <CheckCircleIcon className="w-6 h-6 text-[#2DD4BF] shrink-0 mt-0.5" data-id="element-118" />
              <div data-id="element-119">
                <h3 className="text-[#F1F5F9] font-semibold mb-2 text-lg" data-id="element-120">
                  {item.title}
                </h3>
                <p className="text-[#94A3B8] leading-relaxed" data-id="element-121">{item.desc}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}